import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store';
import { TOGGLE_CHAT_SCREEN } from '../../redux/reducers/chatScreenReducer';
import MyLottie from '../animation';

function ToggleChatButton() {
  const dispatch = useDispatch<AppDispatch>();
  const isChatOpen = useSelector(
    (state: RootState) => state.chatScreen.isChatOpen,
  );


  const toggleChat = () => {
    dispatch({
      type: TOGGLE_CHAT_SCREEN,
    });
  };
  
  const clientType = process.env.REACT_APP_CLIENT;

  return (
    <>
 {!isChatOpen &&   <div
      className="fixed bottom-0 right-2 z-[9990] sm:z-[9999]"
      style={{ zIndex: 2147483647, width: 80, height: 80, position: 'fixed' , bottom: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center'}}
      onClick={toggleChat}
    >
      <button
        id="toggle-chatbot"
        className={`${
          isChatOpen
            ? 'bg-primary p-3 h-5/6 w-5/6 '
            : 'bg-transparent p-0 h-full w-full border-0'
        } text-white justify-center items-center transform hover:scale-[1.04] transition-transform ${
          isChatOpen ? 'rounded-full' : ''
        }`}
        // onClick={toggleChat}
      >
        {isChatOpen ? (
          <div className="transition-opacity  w-full h-full ">
            <svg
              className="text-white dark:text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              // className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
        ) : (clientType === "salesbottax1099" ? (
          <MyLottie width={70} height={70} />
        ) : (
          <div
            className="toggole-chat-logo"
            style={{ width: '100%', height: '100%' }}
          ></div>
        )
        )}
      </button>
    </div>}
    </>
  );
}

export default ToggleChatButton;
